import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/templates/layout.js";
import SEO from './../components/seo';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Frequently Asked Questions - FAQ" description="Frequently Asked Questions" keywords={["ruby on rails", "Ruby on Rails development", "angularjs framework", "angularjs code", "meteor js", "react js", "reactjs native", "node js development", "node js website", "spree commerce", "ruby on rails developer", "react js components", "javascript meteor", "Angular javascript", "angular framework", "js angular", "angular website", "Android Website", "ios app development", "mobile web app", "javascript android app", "web application development company"]} mdxType="SEO" />
    <h1 {...{
      "id": "faq"
    }}>{`FAQ`}</h1>
    <h4 {...{
      "id": "pricing"
    }}>{`Pricing`}</h4>
    <p>{`Our projects typically start from `}<strong parentName="p">{`15k USD`}</strong>{`. We give you a estimate in `}<em parentName="p">{`24 hours`}</em>{` once we get your rough designs`}</p>
    <h4 {...{
      "id": "timelines"
    }}>{`Timelines`}</h4>
    <p>{`Since we have a lot of
`}<a parentName="p" {...{
        "href": "https://github.com/Codebrahma/React-Native-Restaurant-App"
      }}>{`premade`}</a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/Codebrahma/react-lite-ui/"
      }}>{`reusable`}</a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/Codebrahma/cb-react-forms"
      }}>{`components`}</a>{`,
we are typically `}<strong parentName="p">{`40% faster`}</strong>{` than an inhouse solution`}</p>
    <h4 {...{
      "id": "where-are-your-developers"
    }}>{`Where are your developers?`}</h4>
    <p>{`Fremont, Bangalore, Nigeria, Ukraine. You will be communicating with our team via a slack channel, and a lead closest
to your timezone and budget will be working with you.`}</p>
    <h4 {...{
      "id": "intellectual-property"
    }}>{`Intellectual Property`}</h4>
    <p>{`All IP belongs to you. Our open source components are under the liberal MIT license`}</p>
    <h4 {...{
      "id": "how-quickly-can-you-start"
    }}>{`How quickly can you start?`}</h4>
    <p>{`Please start engaging with us when you have atleast 2-3 screens designed. Generally we need atleast 5 days to start your projects.
We are rapidly expanding our team, and we aim to bring this down.`}</p>
    <h4 {...{
      "id": "do-you-do-design"
    }}>{`Do you do design?`}</h4>
    <p><strong parentName="p">{`No`}</strong>{` . We are happy to connect you with our design friends if you request`}</p>
    <h4 {...{
      "id": "do-you-do-backend"
    }}>{`Do you do backend.`}</h4>
    <p>{`No. We do have a sister entity that is focussing on building AWS serverless based backends.
`}<strong parentName="p">{`Lets talk`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      